chunkIds